(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lmmf-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lmmf-showcase')) {
    class LmmfShowcase extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.track = this.querySelector('.lmmf-showcase__track');
        this.slides = Array.from(this.querySelectorAll('.lmmf-showcase__slide'));
        if (!this.track || this.slides.length < 2) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.dots = Array.from(this.querySelectorAll('[data-slide]'));
        this.toggle = this.querySelector('[data-toggle]');
        this.status = this.querySelector('.lmmf-showcase__status');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.interval = Math.min(12000, Math.max(3000, Number(this.dataset.interval) || 6000));
        this.current = 0;
        this.visible = false;
        this.hovered = false;
        this.focused = this.contains(document.activeElement);
        this.hoverOverride = false;
        this.focusOverride = false;
        this.interacting = false;
        this.wantsPlay = this.dataset.autoplay === 'true' && !this.motion.matches;
        this.classList.add('is-enhanced');
        this.querySelector('.lmmf-showcase__controls').hidden = false;
        this.querySelector('[data-previous]').addEventListener('click', () => this.goTo(this.current - 1), { signal });
        this.querySelector('[data-next]').addEventListener('click', () => this.goTo(this.current + 1), { signal });
        this.dots.forEach(dot => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.slide)), { signal }));
        this.toggle.addEventListener('click', () => {
          if (this.canPlay()) {
            this.wantsPlay = false;
          } else {
            this.wantsPlay = true;
            this.hoverOverride = true;
            this.focusOverride = true;
          }
          this.schedule();
        }, { signal });
        this.addEventListener('pointerenter', event => {
          if (event.pointerType !== 'mouse') return;
          this.hovered = true;
          this.hoverOverride = false;
          this.schedule();
        }, { signal });
        this.addEventListener('pointerleave', () => {
          this.hovered = false;
          this.hoverOverride = false;
          this.schedule();
        }, { signal });
        this.addEventListener('focusin', event => {
          this.focused = true;
          this.wantsPlay = false;
          this.focusOverride = false;
          this.schedule();
        }, { signal });
        this.addEventListener('focusout', () => {
          queueMicrotask(() => {
            if (!this.isConnected) return;
            this.focused = this.contains(document.activeElement);
            if (!this.focused) this.focusOverride = false;
            this.schedule();
          });
        }, { signal });
        this.track.addEventListener('pointerdown', () => {
          this.interacting = true;
          this.schedule();
        }, { signal });
        const finishInteraction = () => {
          if (!this.interacting) return;
          this.interacting = false;
          this.schedule();
        };
        document.addEventListener('pointerup', finishInteraction, { signal });
        document.addEventListener('pointercancel', finishInteraction, { signal });
        this.track.addEventListener('scroll', () => {
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(() => {
            this.syncCurrent();
            this.schedule();
          }, 120);
        }, { signal, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.goTo(this.current + (event.key === 'ArrowRight' ? direction : -direction));
          }
        }, { signal });
        document.addEventListener('visibilitychange', () => this.schedule(), { signal });
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) this.wantsPlay = false;
          this.schedule();
        }, { signal });
        this.addEventListener('shopify:block:select', event => {
          const selected = event.target.closest('.lmmf-showcase__slide');
          const index = this.slides.indexOf(selected);
          if (index < 0) return;
          this.wantsPlay = false;
          this.goTo(index, false);
        }, { signal });
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .25;
          this.schedule();
        }, { threshold: [0, .25] });
        this.observer.observe(this);
        this.resizeObserver = new ResizeObserver(() => this.goTo(this.current, false));
        this.resizeObserver.observe(this.track);
        this.setCurrent(0);
        this.schedule();
      }
      canPlay() {
        return this.wantsPlay && this.visible && !document.hidden && !this.interacting && (!this.hovered || this.hoverOverride) && (!this.focused || this.focusOverride);
      }
      schedule() {
        clearTimeout(this.timer);
        this.progressAnimation?.cancel();
        const playing = this.canPlay();
        this.dataset.playing = String(playing);
        this.toggle.querySelector('[data-toggle-label]').textContent = playing ? this.dataset.pause : this.dataset.play;
        this.status.setAttribute('aria-live', playing ? 'off' : 'polite');
        if (playing) {
          if (!this.motion.matches) {
            const progress = this.dots[this.current]?.querySelector('.lmmf-showcase__progress');
            this.progressAnimation = progress?.animate([{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }], { duration: this.interval, easing: 'linear', fill: 'forwards' });
          }
          this.timer = setTimeout(() => this.goTo(this.current + 1), this.interval);
        }
      }
      goTo(index, animate = true) {
        const target = (index + this.slides.length) % this.slides.length;
        const trackRect = this.track.getBoundingClientRect();
        const slideRect = this.slides[target].getBoundingClientRect();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const distance = rtl ? slideRect.right - trackRect.right : slideRect.left - trackRect.left;
        this.track.scrollBy({ left: distance, behavior: animate && !this.motion.matches ? 'smooth' : 'instant' });
        if (!animate || this.motion.matches) this.setCurrent(target);
        this.schedule();
      }
      syncCurrent() {
        const trackRect = this.track.getBoundingClientRect();
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        let nearest = 0;
        let distance = Infinity;
        this.slides.forEach((slide, index) => {
          const rect = slide.getBoundingClientRect();
          const delta = Math.abs(rtl ? rect.right - trackRect.right : rect.left - trackRect.left);
          if (delta < distance) {
            distance = delta;
            nearest = index;
          }
        });
        this.setCurrent(nearest);
      }
      setCurrent(index) {
        const changed = this.current !== index;
        this.current = index;
        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === index;
          slide.classList.toggle('is-current', active);
          slide.inert = !active;
        });
        this.dots.forEach((dot, dotIndex) => {
          if (dotIndex === index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        this.querySelector('[data-current]').textContent = String(index + 1).padStart(2, '0');
        if (changed) this.status.textContent = this.slides[index].dataset.announcement;
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        clearTimeout(this.scrollTimer);
        this.progressAnimation?.cancel();
        this.controller?.abort();
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        this.controller = null;
      }
    }
    customElements.define('lmmf-showcase', LmmfShowcase);
  }

  } catch(e) { console.error(e); }
})();
})();
